import { useCallback } from 'react';
import { useDataProvider } from 'react-admin';
import { AVATARS } from '../../../providers/resources';
import { extractShortFromUrl } from '../../../utils/qr/extractShortFromUrl';

export interface FindAvatarByQrResult {
    record: any | null;
    short: string;
}

/**
 * Busca un avatar a partir del texto decodificado de un QR (URL yourls),
 * filtrando por `mcs.yourls.short`. Función pura para poder testearla con
 * un dataProvider simulado.
 */
export async function findAvatarByQr(
    dataProvider: any,
    decodedText: string,
): Promise<FindAvatarByQrResult> {
    const short = extractShortFromUrl(decodedText);
    const { data } = await dataProvider.getList(AVATARS, {
        pagination: { page: 1, perPage: 10 },
        sort: { field: 'id', order: 'ASC' },
        filter: { 'mcs.yourls.short': short },
    });
    return { record: data?.[0] ?? null, short };
}

/** Hook que liga `findAvatarByQr` al dataProvider del contexto. */
export const useFindAvatarByQr = () => {
    const dataProvider = useDataProvider();
    return useCallback(
        (decodedText: string) => findAvatarByQr(dataProvider, decodedText),
        [dataProvider],
    );
};
